import {FC, useState, useEffect} from 'react'
import BtnClose from '../../components/BtnClose'
import styled from '@emotion/styled'
import * as API from '../../api'
import Select from 'react-select'
import ReportFilter from './ReportFilter'
import {useDistributors, useIndustries} from '../../modules/auth'

const Style = styled.div`
  .modal-container {
    width: 100%;
  }

  .form-group {
    margin-bottom: 1rem;
    align-items: baseline;
    display: flex;
  }

  .form-label {
    display: block;
    margin-bottom: 0.5rem;
  }

  .form-input {
    display: block;
    width: 100%;
    margin-bottom: 1rem;
  }

  .filter-btn {
    width: 100%;
    padding: 0.5rem 1rem;
    margin-top: 1rem;
  }

  .multi-select {
    width: 100%;
    margin-top: 1rem;
  }

  .mailling-item {
    margin-right: 30px;

    label {
      margin-right: 10px;
    }
  }
`

type Props = {
  onChange: Function
  onClose: Function
  data: any
  type: string
}

const LojistasFilterModal: FC<Props> = (props) => {
  const distributors = useDistributors()
  const industries = useIndustries()

  const [loading, setLoading] = useState(false)

  const [selectedDistributors, setSelectedDistributors] = useState<any[]>([])
  const [selectedIndustries, setSelectedIndustries] = useState<any[]>([])

  const [status, setStatus] = useState<string>('')
  const [cnpj, setCNPJ] = useState<string>('')
  const [politicaPreco, setPoliticaPreco] = useState<string>('')

  const [isBlockList, setIsBlockList] = useState<string>('')
  const [unidadeNegocio, setUnidadeNegocio] = useState<string>('')

  const [filter, setFilter] = useState<any>(null)

  function maskCNPJ(value:any) {
    if (!value) return ''

    // Permite letras e números, remove pontuação, deixa maiúsculo
    const raw = value.toUpperCase().replace(/[^0-9A-Z]/g, '')

    // 12 primeiras posições podem ser alfanuméricas
    const first12 = raw.slice(0, 12)

    // DV (2 últimas) devem ser numéricas
    const dv = raw.slice(12, 14).replace(/[^0-9]/g, '')

    const clean = (first12 + dv).slice(0, 14)

    const p1 = clean.slice(0, 2)
    const p2 = clean.slice(2, 5)
    const p3 = clean.slice(5, 8)
    const p4 = clean.slice(8, 12)
    const p5 = clean.slice(12, 14)

    let out = p1
    if (p2) out += '.' + p2
    if (p3) out += '.' + p3
    if (p4) out += '/' + p4
    if (p5) out += '-' + p5

    return out
  }

  function unmaskCNPJ(value:any) {
    if (!value) return ''
    return value.toUpperCase().replace(/[^0-9A-Z]/g, '')
  }

  useEffect(() => {
    setLoading(false)
  }, [])

  useEffect(() => {
    if (filter || props.data) {
      const data = filter?.data || props.data
      if (data.status) setStatus(data.status)
      if (data.distributors) setSelectedDistributors(data.distributors)
      if (data.industries) setSelectedIndustries(data.industries)
      if (data.cnpj) setCNPJ(maskCNPJ(data.cnpj))
      if (data.politicaPreco) setPoliticaPreco(data.politicaPreco)
      if (data.isBlockList) setIsBlockList(data.isBlockList)
      if (data.unidadeNegocio) setUnidadeNegocio(data.unidadeNegocio)
    }
  }, [props.data, filter])

  function getData() {
    return {
      status,
      cnpj: unmaskCNPJ(cnpj),
      distributors: selectedDistributors,
      industries: selectedIndustries,
      politicaPreco,
      isBlockList,
      unidadeNegocio,
    }
  }

  return (
    <Style>
      <div className='modal-container'>
        <div className='px-7 py-5 d-flex justify-content-between'>
          <div className='pt-2 fs-3 text-dark fw-bolder'>Filtros para o relatório</div>
          <BtnClose onClick={() => props.onClose()} />
        </div>
        <ReportFilter name={props.type} filter={getData()} setFilter={setFilter}></ReportFilter>
        <div className='separator border-gray-200'></div>
        <div className='px-7 py-5'>
          <div className='mb-4 d-flex flex-wrap'>
            <div className=' justify-content-between modal-container'>
              <div className='form-group'>
                <label className='form-label fw-bold me-2 w-200px'>Status:</label>
                <select
                  disabled={loading}
                  className='form-select form-select-solid'
                  data-kt-select2='true'
                  data-placeholder=''
                  data-allow-clear='true'
                  value={status}
                  onChange={(evt: any) => setStatus(evt.target.value)}
                >
                  <option value=''>Todos</option>
                  <option value='PREAPV'>Pré-Aprovado</option>
                  <option value='APV'>Aprovado</option>
                  <option value='RPV'>Reprovado</option>
                </select>
              </div>

              <div className='form-group'>
                <label className='form-label fw-bold me-2 w-200px'>CNPJ:</label>
                <input
                  className='form-input form-control'
                  type="text"
  disabled={loading}
  value={cnpj}
  onChange={(e) => setCNPJ(maskCNPJ(e.target.value))}
  onPaste={(e) => {
    e.preventDefault()
    const paste = e.clipboardData.getData('Text')
    setCNPJ(maskCNPJ(paste))
  }}
  placeholder="00.000.000/0000-00"
/>
                
              </div>

              <div className='form-group'>
                <label className='form-label fw-bold me-2 w-200px'>Distribuidor:</label>
                <Select
                  isMulti
                  isDisabled={loading}
                  options={distributors}
                  value={selectedDistributors}
                  placeholder={'Filtrar por Distribuidor'}
                  closeMenuOnSelect={false}
                  onChange={(selected: any) => setSelectedDistributors(selected)}
                  className='multi-select'
                />
              </div>

              <div className='form-group'>
                <label className='form-label fw-bold me-2 w-200px'>Indústria:</label>
                <Select
                  isMulti
                  isDisabled={loading}
                  options={industries}
                  value={selectedIndustries}
                  placeholder={'Filtrar por Indústria'}
                  closeMenuOnSelect={false}
                  onChange={(selected: any) => setSelectedIndustries(selected)}
                  className='multi-select'
                />
              </div>

              <div className='form-group'>
                <label className='form-label fw-bold me-2 w-200px'>Politica Preço:</label>
                <input
                  className='form-input form-control'
                  type='text'
                  disabled={loading}
                  defaultValue={politicaPreco}
                  onChange={(e) => {
                    setPoliticaPreco(e.target.value)
                  }}
                ></input>
              </div>

              <div className='form-group'>
                <label className='form-label fw-bold me-2 w-200px'>Blocklist:</label>
                <div className='form-control d-flex'>
                  <div className='mailling-item'>
                    <label>Todos</label>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='blocklist'
                      value=''
                      checked={isBlockList === ''}
                      onChange={({target: {value}}) => {
                        setIsBlockList(value)
                      }}
                    />
                  </div>
                  <div className='mailling-item'>
                    <label>Sim</label>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='blocklist'
                      value='SIM'
                      checked={isBlockList === 'SIM'}
                      onChange={({target: {value}}) => {
                        setIsBlockList(value)
                      }}
                    />
                  </div>
                  <div className='mailling-item'>
                    <label>Não</label>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='blocklist'
                      value='NAO'
                      checked={isBlockList === 'NAO'}
                      onChange={({target: {value}}) => {
                        setIsBlockList(value)
                      }}
                    />
                  </div>
                </div>
              </div>

              {/*<div className='form-group'>
                <label className='form-label fw-bold me-2 w-200px'>Abrir por Unidade de Negócio:</label>
                <div className='form-control d-flex'>
                  <div className='mailling-item'>
                    <label>Todos</label>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='unidadeNegocio'
                      value=''
                      checked={unidadeNegocio === ''}
                      onChange={({target: {value}}) => {
                        setUnidadeNegocio(value)
                      }}
                    />
                  </div>
                  <div className='mailling-item'>
                    <label>Sim</label>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='unidadeNegocio'
                      value='SIM'
                      checked={unidadeNegocio === 'SIM'}
                      onChange={({target: {value}}) => {
                        setUnidadeNegocio(value)
                      }}
                    />
                  </div>
                  <div className='mailling-item'>
                    <label>Não</label>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='unidadeNegocio'
                      value='NAO'
                      checked={unidadeNegocio === 'NAO'}
                      onChange={({target: {value}}) => {
                        setUnidadeNegocio(value)
                      }}
                    />
                  </div>
                </div>
              </div> */}

              <button
                onClick={() => {
                  setLoading(true)
                  props.onChange(getData())
                }}
                className='btn btn-primary filter-btn'
              >
                {!loading && 'Filtrar'}{' '}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Aguarde...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Style>
  )
}

export default LojistasFilterModal
